<template>
  <transition name="fade-scale">
    <button
      v-show="isVisible"
      class="scroll-to-top scrollToTop"
      @click="scrollToTop"
      aria-label="返回顶部"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>
  </transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isVisible = ref(false)

const handleScroll = () => {
  isVisible.value = window.scrollY > window.innerHeight * 0.5
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 40%;
  right: 1.88rem;
  width: 3rem;
  height: 3rem;
  background: #4779B5;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 999;
  /* box-shadow: 0 0.25rem 1.25rem rgba(201, 169, 110, 0.4); */
  transition: all 0.3s ease;
  color: #ffffff;
}

.scroll-to-top:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.38rem 1.88rem rgba(71, 121, 181, 0.6);
}

.scroll-to-top:active {
  transform: translateY(-0.13rem);
}

/* 过渡动画 */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(1.25rem);
}

@media (max-width: 48rem) {
  .scroll-to-top {
    bottom: 1.56rem;
    right: 1.25rem;
    width: 2.75rem;
    height: 2.75rem;
  }
}
</style>
